import showSplitTestTrigger from '@coolblue-development/ga4-events/triggers/SplitTest/showSplitTestTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useRef } from 'react';
export const useTrackableT = ({ t, resource, prefix, keysWithVariation, }) => {
    const { trackEvent } = useAnalytics();
    const firedSplitTestEvents = useRef(new Set());
    const tProxy = new Proxy(t, {
        apply: (target, thisArgs, args) => {
            const variationIds = flattenKeys(args[0])
                .map((key) => { var _a; return (_a = keysWithVariation[resource]) === null || _a === void 0 ? void 0 : _a[`${prefix}.${key}`]; })
                .filter((key) => Boolean(key));
            for (const variationId of variationIds) {
                if (firedSplitTestEvents.current.has(variationId)) {
                    continue;
                }
                firedSplitTestEvents.current.add(variationId);
                trackEvent(showSplitTestTrigger({
                    test_name: '',
                    variation_id: variationId,
                }));
            }
            return Reflect.apply(target, thisArgs, args);
        },
    });
    return tProxy;
};
const flattenKeys = (keys) => {
    const result = [];
    (isString(keys) ? [keys] : keys).forEach(key => {
        result.push(...(isString(key) ? [key] : key));
    });
    return result;
};
const isString = (input) => typeof input === 'string';
//# sourceMappingURL=useTrackableT.js.map